/******************************************************************************
 *
 * Copyright (c) 2017, the Perspective Authors.
 *
 * This file is part of the Perspective library, distributed under the terms of
 * the Apache License 2.0.  The full license can be found in the LICENSE file.
 *
 */

import { is_editable, write_cell } from "./edit_click.js";

export function focusoutListener(table, viewer, selected_position_map, event) {
    if (is_editable.call(this, viewer) && selected_position_map.has(table)) {
        event.target.classList.remove("psp-error");
        const selectedPosition = selected_position_map.get(table);
        selected_position_map.delete(table);
        if (selectedPosition.content !== event.target.textContent) {
            if (!write_cell(table, this, event.target)) {
                event.target.textContent = selectedPosition.content;
                event.target.classList.add("psp-error");
                event.target.focus();
            }
        }
    }
}

export function focusinListener(table, _viewer, selected_position_map, event) {
    const meta = table.getMeta(event.target);
    if (meta) {
        const new_state = {
            x: meta.x,
            y: meta.y,
            content: event.target.textContent,
        };
        selected_position_map.set(table, new_state);
    }
}
